export const fallbackLng = 'en';
export const translatedLocales = [
  fallbackLng,
  'cs',
  'da',
  'de',
  'es',
  'et',
  'fi',
  'fr',
  'hu',
  'it',
  'ja',
  'lt',
  'nl',
  'no',
  'pl',
  'pt',
  'sl',
  'sv',
] as const;
